import axios from 'axios';
import { yotpoMixin } from '../../mixins/yotpo-mixins';
import {
  SizePurchased,
  CustomerHeight,
  CustomerWeight,
  BodyType,
} from '../../enums/yotpo';

export default {
  name: 'reviewForms',

  props: {
    productId: String,
    productTitle: String,
    productUrl: String,
  },

  mixins: [yotpoMixin],

  data() {
    return {
      reviewForm: {
        sku: this.productId,
        product_title: this.productTitle,
        product_url: 'https://www.cotopaxi.com' + this.productUrl,
        display_name: '',
        email: '',
        review_title: '',
        review_content: '',
        review_score: 0,
        custom_fields: {
          '--51722': 0,
        },
      },

      //error handling - review form
      formErrors: {
        displayName: null,
        email: null,
        rating: null,
        title: null,
        content: null,
      },
      reviewSubmitted: false,
      SizePurchased,
      CustomerHeight,
      CustomerWeight,
      BodyType,
    };
  },

  methods: {
    postReview() {
      axios
        .post(
          `https://production-access-api.cotopaxi.com/yotpo/review`,
          this.reviewForm
        )
        .then((response) => {
          if (response.status == 200) {
            this.reviewSubmitted = true;
          }
          this.resetForm('review');
        })
        .catch((error) => console.error(error));
    },
  },
};
